/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { ThemeTokens } from '@acp/core-ui';
import {
    BorderProps,
    Card,
    CardBody,
    CardBodyProps,
    GridItem,
    GridItemProps,
    HStack,
    VStack,
} from '@chakra-ui/react';

const gap = 2;

const gridAreaProps: { [key: string]: GridItemProps } = {
    service: {
        gridArea: 'service',
        as: VStack,
        alignItems: { base: 'center', xl: 'start' },
        justifyContent: 'flex-start',
        gap,
    },
    'reported-findings': {
        gridArea: 'reported-findings',
    },
    status: {
        gridArea: 'status',
    },
    actions: {
        gridArea: 'actions',
        as: HStack,
        justifySelf: 'flex-end',
        gap,
    },
};

type AreaType = keyof typeof gridAreaProps;

interface RowColumnProps extends GridItemProps {
    area: AreaType;
}

export function RowLayout({
    children,
    borderLeftColor = 'secondary.500',
}: {
    children: React.ReactNode;
    borderLeftColor?: BorderProps['borderLeftColor'];
}) {
    return (
        <Card
            borderColor={ThemeTokens.Defaults.borderColor}
            borderWidth={1}
            borderLeftWidth={6}
            borderLeftColor={borderLeftColor}
            bg="white"
            variant="filled"
            w="full"
            shadow="sm"
            p={5}
        >
            {children}
        </Card>
    );
}

function RowBody({ children, as: Component, ...props }: CardBodyProps) {
    return (
        <CardBody as={Component} {...props}>
            {children}
        </CardBody>
    );
}

function RowColumn({ children, area, ...props }: RowColumnProps) {
    const gridItemAreaProps = gridAreaProps[area];

    return (
        <GridItem {...gridItemAreaProps} {...props}>
            {children}
        </GridItem>
    );
}

RowLayout.Body = RowBody;
RowLayout.Column = RowColumn;
